var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "report-tab-layout",
    {
      scopedSlots: _vm._u([
        {
          key: "card-footer",
          fn: function () {
            return [
              _c("report-toolbar", {
                attrs: {
                  "set-default-props": _vm.settingDefault,
                  "report-props": Object.assign({}, _vm.runningReport, {
                    disabled: !_vm.isValid,
                  }),
                },
                on: {
                  "clear-selection": _vm.handleClearSelection,
                  "reset-to-default": _vm.handleResetToDefault,
                  "set-default": _vm.handleSetDefault,
                  "run-report": _vm.handleRunReport,
                },
              }),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _vm.loading
        ? _c("renewal-tracking-container-loader")
        : _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { cols: "12" } },
                [
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { staticClass: "mb-3", attrs: { cols: "12", sm: "6" } },
                        [
                          _c(
                            "h6",
                            { staticClass: "bold form-title font-sm mb-0" },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.$t("application-reports.level")) +
                                  "\n            "
                              ),
                              _c("input-required-indicator"),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("select-level", {
                            attrs: {
                              "selected-level":
                                _vm.localRenewalTrackingData.level,
                            },
                            on: {
                              "update:selectedLevel": function ($event) {
                                return _vm.$set(
                                  _vm.localRenewalTrackingData,
                                  "level",
                                  $event
                                )
                              },
                              "update:selected-level": function ($event) {
                                return _vm.$set(
                                  _vm.localRenewalTrackingData,
                                  "level",
                                  $event
                                )
                              },
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.showAgentsSelect
                        ? _c(
                            "b-col",
                            {
                              staticClass: "mb-3",
                              attrs: { cols: "12", sm: "6" },
                            },
                            [
                              _c(
                                "h6",
                                {
                                  staticClass:
                                    "bold mb-1 form-title font-sm text-capitalize",
                                },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(_vm.$tc("global.doorr.agent", 1)) +
                                      "\n          "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("agents-select", {
                                attrs: {
                                  "default-value":
                                    _vm.localRenewalTrackingData.agent,
                                  value: _vm.localRenewalTrackingData.agent,
                                  "select-options": _vm.agentsOptions,
                                  "space-classes":
                                    "form-group-material form-group-material-no-label",
                                  label: "",
                                  "has-checkboxes": "",
                                  "close-on-select-all": "",
                                  "extra-select-data": [_vm.allAgentsOption],
                                },
                                on: { change: _vm.handleSelectAgentChange },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { staticClass: "mb-3", attrs: { cols: "12", sm: "6" } },
                        [
                          _c(
                            "h6",
                            { staticClass: "bold form-title font-sm mb-0" },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.$t("application-reports.format")) +
                                  "\n            "
                              ),
                              _c("input-required-indicator"),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("select-format", {
                            attrs: {
                              "selected-format":
                                _vm.localRenewalTrackingData.format,
                              action: _vm.action,
                            },
                            on: {
                              "update:selectedFormat": function ($event) {
                                return _vm.$set(
                                  _vm.localRenewalTrackingData,
                                  "format",
                                  $event
                                )
                              },
                              "update:selected-format": function ($event) {
                                return _vm.$set(
                                  _vm.localRenewalTrackingData,
                                  "format",
                                  $event
                                )
                              },
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { staticClass: "mb-3", attrs: { cols: "12", sm: "6" } },
                        [
                          _c(
                            "h6",
                            { staticClass: "bold form-title font-sm mb-0" },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.$t("application-reports.lender")) +
                                  "\n            "
                              ),
                              _c("input-required-indicator"),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("select-lender", {
                            attrs: {
                              "selected-lender":
                                _vm.localRenewalTrackingData.lender,
                              multiple: "",
                              clearable: "",
                              action: _vm.action,
                              "default-value":
                                _vm.localRenewalTrackingData.lender,
                            },
                            on: {
                              "update:selectedLender": function ($event) {
                                return _vm.$set(
                                  _vm.localRenewalTrackingData,
                                  "lender",
                                  $event
                                )
                              },
                              "update:selected-lender": function ($event) {
                                return _vm.$set(
                                  _vm.localRenewalTrackingData,
                                  "lender",
                                  $event
                                )
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { staticClass: "mb-3", attrs: { cols: "12", lg: "6" } },
                        [
                          _c(
                            "h6",
                            { staticClass: "bold form-title font-sm mb-0" },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.$t("application-reports.mortgageType")
                                  ) +
                                  "\n            "
                              ),
                              _c("input-required-indicator"),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("select-mortgage-type", {
                            attrs: {
                              "selected-mortgage-type":
                                _vm.localRenewalTrackingData.mortgageType,
                              multiple: "",
                              action: _vm.action,
                            },
                            on: {
                              "update:selectedMortgageType": function ($event) {
                                return _vm.$set(
                                  _vm.localRenewalTrackingData,
                                  "mortgageType",
                                  $event
                                )
                              },
                              "update:selected-mortgage-type": function (
                                $event
                              ) {
                                return _vm.$set(
                                  _vm.localRenewalTrackingData,
                                  "mortgageType",
                                  $event
                                )
                              },
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { attrs: { cols: "12", lg: "6" } },
                        [
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                {
                                  staticClass: "mb-3",
                                  attrs: { cols: "12", sm: "6" },
                                },
                                [
                                  _c(
                                    "h6",
                                    { staticClass: "form-title font-sm mb-0" },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.$t(
                                              "application-reports.renewal-tracking.renewalDateFrom"
                                            )
                                          ) +
                                          "\n                "
                                      ),
                                      _c("input-required-indicator"),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "field",
                                    [
                                      _c("date-section", {
                                        attrs: {
                                          id: "application-summary-date-from",
                                          "maturity-date": "",
                                          placeholder: "YYYY-MM-DD",
                                          "max-date":
                                            _vm.localRenewalTrackingData.dateTo,
                                        },
                                        model: {
                                          value:
                                            _vm.localRenewalTrackingData
                                              .dateFrom,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.localRenewalTrackingData,
                                              "dateFrom",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "localRenewalTrackingData.dateFrom",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                {
                                  staticClass: "mb-3",
                                  attrs: { cols: "12", sm: "6" },
                                },
                                [
                                  _c(
                                    "h6",
                                    { staticClass: "form-title font-sm mb-0" },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.$t("application-reports.dateTo")
                                          ) +
                                          "\n                "
                                      ),
                                      _c("input-required-indicator"),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "field",
                                    [
                                      _c("date-section", {
                                        attrs: {
                                          id: "application-summary-date-to",
                                          "maturity-date": "",
                                          placeholder: "YYYY-MM-DD",
                                          "min-date":
                                            _vm.localRenewalTrackingData
                                              .dateFrom,
                                        },
                                        model: {
                                          value:
                                            _vm.localRenewalTrackingData.dateTo,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.localRenewalTrackingData,
                                              "dateTo",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "localRenewalTrackingData.dateTo",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { staticClass: "mb-3", attrs: { cols: "12", lg: "6" } },
                        [
                          _c(
                            "h6",
                            { staticClass: "bold form-title font-sm mb-0" },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.$t("application-reports.requestType")
                                  ) +
                                  "\n            "
                              ),
                              _c("input-required-indicator"),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("select-request-type", {
                            attrs: {
                              "selected-request-type":
                                _vm.localRenewalTrackingData.requestType,
                              multiple: "",
                              action: _vm.action,
                            },
                            on: {
                              "update:selectedRequestType": function ($event) {
                                return _vm.$set(
                                  _vm.localRenewalTrackingData,
                                  "requestType",
                                  $event
                                )
                              },
                              "update:selected-request-type": function (
                                $event
                              ) {
                                return _vm.$set(
                                  _vm.localRenewalTrackingData,
                                  "requestType",
                                  $event
                                )
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { staticClass: "mb-3", attrs: { cols: "12", lg: "6" } },
                        [
                          _c(
                            "h6",
                            { staticClass: "bold form-title font-sm mb-0" },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.$t("application-reports.groupBy")
                                  ) +
                                  "\n            "
                              ),
                              _c("input-required-indicator"),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "material-input",
                            {
                              staticClass: "no-border",
                              attrs: { id: "select-group-by", "no-label": "" },
                              model: {
                                value: _vm.localRenewalTrackingData.groupBy,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.localRenewalTrackingData,
                                    "groupBy",
                                    $$v
                                  )
                                },
                                expression: "localRenewalTrackingData.groupBy",
                              },
                            },
                            [
                              _c("v-select-field", {
                                staticClass: "search-input w-100 simple-dd",
                                attrs: {
                                  options: _vm.groupByOptions,
                                  placeholder: _vm.$t(
                                    "global.actions.chooseOption"
                                  ),
                                  value: _vm.localRenewalTrackingData.groupBy,
                                  clearable: false,
                                  label: "text",
                                  "default-value":
                                    _vm.localRenewalTrackingData.groupBy,
                                  action: _vm.action,
                                },
                                on: {
                                  "option:selected": function (ref) {
                                    var id = ref.id

                                    return (_vm.localRenewalTrackingData.groupBy =
                                      id)
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { attrs: { cols: "12", lg: "6" } },
                        [
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                {
                                  staticClass: "mb-3",
                                  attrs: { sm: "6", cols: "12" },
                                },
                                [
                                  _c(
                                    "h6",
                                    { staticClass: "form-title font-sm mb-0" },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.$t(
                                              "application-reports.applications-summary.firstSortBy"
                                            )
                                          ) +
                                          "\n                "
                                      ),
                                      _c("input-required-indicator"),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "material-input",
                                    {
                                      staticClass: "no-border",
                                      attrs: {
                                        id: "select-sort-by-1",
                                        "no-label": "",
                                      },
                                      model: {
                                        value:
                                          _vm.localRenewalTrackingData
                                            .sortBy[0],
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.localRenewalTrackingData.sortBy,
                                            0,
                                            $$v
                                          )
                                        },
                                        expression:
                                          "localRenewalTrackingData.sortBy[0]",
                                      },
                                    },
                                    [
                                      _c("v-select-field", {
                                        staticClass:
                                          "search-input w-100 simple-dd",
                                        attrs: {
                                          options: _vm.primaryOptions,
                                          placeholder: _vm.$t(
                                            "global.actions.chooseOption"
                                          ),
                                          value:
                                            _vm.localRenewalTrackingData
                                              .sortBy[0],
                                          clearable: false,
                                          label: "text",
                                          scenario: "reports",
                                          "default-value":
                                            _vm.localRenewalTrackingData
                                              .sortBy[0],
                                          action: _vm.action,
                                        },
                                        on: {
                                          "option:selected": function (value) {
                                            return _vm.handleChangeSortBy(
                                              value,
                                              0
                                            )
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                {
                                  staticClass: "mb-3",
                                  attrs: { sm: "6", cols: "12" },
                                },
                                [
                                  _c(
                                    "h6",
                                    { staticClass: "form-title font-sm mb-0" },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.$t(
                                              "application-reports.applications-summary.secondSortBy"
                                            )
                                          ) +
                                          "\n                "
                                      ),
                                      _c("input-required-indicator"),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "material-input",
                                    {
                                      staticClass: "no-border",
                                      attrs: {
                                        id: "select-sort-by-2",
                                        "no-label": "",
                                      },
                                      model: {
                                        value:
                                          _vm.localRenewalTrackingData
                                            .sortBy[1],
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.localRenewalTrackingData.sortBy,
                                            1,
                                            $$v
                                          )
                                        },
                                        expression:
                                          "localRenewalTrackingData.sortBy[1]",
                                      },
                                    },
                                    [
                                      _c("v-select-field", {
                                        staticClass:
                                          "search-input w-100 simple-dd",
                                        attrs: {
                                          options: _vm.secondaryOptions,
                                          placeholder: _vm.$t(
                                            "global.actions.chooseOption"
                                          ),
                                          value:
                                            _vm.localRenewalTrackingData
                                              .sortBy[1],
                                          clearable: false,
                                          label: "text",
                                          scenario: "reports",
                                          "default-value":
                                            _vm.localRenewalTrackingData
                                              .sortBy[1],
                                          action: _vm.action,
                                        },
                                        on: {
                                          "option:selected": function (value) {
                                            return _vm.handleChangeSortBy(
                                              value,
                                              1
                                            )
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }